var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "black",
    viewBox: "0 0 16 16",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 5a.5.5 0 100-1 .5.5 0 000 1zM3 4.5a.5.5 0 11-1 0 .5.5 0 011 0zm2 7a.5.5 0 11-1 0 .5.5 0 011 0zm-2.5.5a.5.5 0 100-1 .5.5 0 000 1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2a2 2 0 00-2 2v1a2 2 0 002 2h1v2H2a2 2 0 00-2 2v1a2 2 0 002 2h12a2 2 0 002-2v-1a2 2 0 00-2-2h-1V7h1a2 2 0 002-2V4a2 2 0 00-2-2H2zm13 2v1a1 1 0 01-1 1H2a1 1 0 01-1-1V4a1 1 0 011-1h12a1 1 0 011 1zm0 7v1a1 1 0 01-1 1H2a1 1 0 01-1-1v-1a1 1 0 011-1h12a1 1 0 011 1zm-3-4v2H4V7h8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRack);
export default __webpack_public_path__ + "res/media/rack.98bf0c332e6bea2d57e2508826479e40.svg";
export { ForwardRef as ReactComponent };